<template>
	<!-- 出差申请 -->
	<div>
		<div v-show="Ccsq">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">出差申请</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:20px"></div>
					<el-row>
						<el-col :lg="8" :xl="6" style="margin-top: 10px;">
							<span>组织架构 </span>
							<el-cascader v-model="condition.organize_ids" clearable
								style="margin-left:10px;width:70%" collapse-tags :props="props"></el-cascader>
						</el-col>

						<el-col :lg="5" :xl="4"  style="margin-top: 10px;">
							<span>城市 </span>
							<el-select v-model="condition.city_id" style="margin-left:10px;width:70%"
								:placeholder="postPlaceholder" clearable>
								<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
									:value="item.city">
								</el-option>
							</el-select>
						</el-col>
 
						<el-col :lg="6" :xl="5" style="margin-top: 10px;">
							<span>出差时间 </span>
							<el-date-picker style="width:70%; margin-left:10px" v-model="condition.date" type="datetime"
								placeholder="请选择" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-col>

						<el-col :lg="5" :xl="4" style="margin-top: 10px;">
							<span>姓名 </span>
							<el-input v-model="condition.staff_name" style="margin-left:10px;width:70%"
								placeholder="请输入姓名"></el-input>
						</el-col>

						<el-col :lg="5" :xl="4" style="margin-top: 10px;">
							<span>状态 </span>
							<el-select v-model="condition.state" style="margin-left:10px;width:70%" placeholder="请选择"
								clearable>
								<el-option v-for="item in ztList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-col>

						<el-col :lg="6" :xl="{span: 5, offset: 18}" style="float: right; margin-top: 20px;">
							<el-button type="goon" @click="Find">查询</el-button>
							<el-button type="goon" @click="Del(null)">删除</el-button>
							<el-button type="addbtn" @click="add">新增</el-button>
						</el-col>
					</el-row>
				</div>

				<!-- 表格 -->
				<div style="margin:1% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{$globals.group_name + "/" + scope.row.staff.range}}
							</template>
						</el-table-column>
						<el-table-column prop="staff.city_id" align="center" label="城市"></el-table-column>
						<el-table-column prop="staff.post_name" align="center" label="职位"></el-table-column>
						<el-table-column prop="staff.staff_name" align="center" label="姓名"></el-table-column>
						<el-table-column prop="staff.staff_card" align="center" label="身份证号码"></el-table-column>
						<el-table-column prop="staff.staff_telephone" align="center" label="手机号"></el-table-column>
						<el-table-column prop="evection_reason" align="center" label="出差事由"></el-table-column>
						<el-table-column prop="evectionNum" align="center" label="行程"></el-table-column>
						<el-table-column prop="start_date" align="center" label="开始时间"></el-table-column>
						<el-table-column prop="end_date" align="center" label="结束时间"></el-table-column>
						<el-table-column prop="evection_duration" align="center" label="出差时长(小时)"></el-table-column>
						<el-table-column prop="together_evections" align="center" label="同行人"></el-table-column>
						<el-table-column align="center" label="状态" width=100>
							<template slot-scope="scope">
								<img src="../../../assets/待审批.png" v-show="scope.row.template_state === '0'" />
								<img src="../../../assets/已同意.png" v-show="scope.row.template_state === '3'" />
								<img src="../../../assets/stateImg/状态_已驳回.png"
									v-show="scope.row.template_state === '1'" />
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="150" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/详情.png" @click="Details(scope.row)">
								<img src="../../../assets/编辑.png" @click="Edit(scope.row)">
								<img src="../../../assets/删除.png" @click="Del(scope.row.id)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<add ref="adds" v-show="showadd"></add>
		<edit ref="edit" v-show="showDetails"></edit>
	</div>
</template>

<script>
	import add from './Ccsq_add.vue';
	import edit from './Ccsq_edit.vue';
	import axios from 'axios';
	export default {
		components: {
			add: add,
			edit: edit,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//条件
				condition: {
					organize_ids: [],
					city_id: '',
					date: '',
					staff_name: '',
					state: '',
				},

				//详情
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					staff_names:'',
					evection_reason: '',
					together_evection: '',
					together_evection_name: '',
					evectionTripList: [{
						id: "",
						dictionaries_id: "",
						dictionaries_data: "",
						start_city: "",
						end_city: "",
						trip_type: "",
						trip_duration: "",
						start_date: "",
						end_date: "",
					}],
					evectionTrip: {
						id: "",
						dictionaries_id: "",
						start_city: "",
						end_city: "",
						trip_type: "",
						trip_duration: "",
						start_date: "",
						end_date: "",
					},
					examineDetailsList: [],
				},

				//页面相关
				dialogVisible: false,

				// 权限
				Ccsq: true,
				showadd: false,
				showDetails: false,


				//删除ids
				ids: [],

				//状态
				ztList: [{
					value: '0',
					label: '待审批'
				}, {
					value: '1',
					label: '已同意'
				}, {
					value: '2',
					label: '已驳回'
				}],
				
				//组织架构数据
				organizeList: [],
				
				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
				    value: "id",
				    label: "organize_name",
				    children: "organizeList",
				    checkStrictly: true,
				    multiple: true,
				},
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			// 返回
			Return() {
				this.showadd = false;
				this.Ccsq = true;
				this.showDetails = false;
				this.Find();
				this.trash();
			},
			// 弹窗
			handleClose() {
				this.dialogVisible = false
			},
			// 新增
			add() {
				this.Ccsq = false;
				this.showadd = true;
				this.trash();
			},
			//详情
			async Details(e) {
				this.Ccsq = false;
				this.showDetails = true;

				this.ruleForm.id = e.id;
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.evection_reason = e.evection_reason;
				this.ruleForm.together_evection = e.together_evection;
				this.ruleForm.staff_name = e.staff.staff_name;

				var evectionTripList = await this.$globals.AxiosPost("EvectionTrip/SelectDetails", {
					evection_id: e.id
				});
				this.ruleForm.evectionTripList = evectionTripList.data;

				this.$refs["edit"].Initialize();
			},
			// 修改
			async Edit(e) {
				this.Ccsq = false;
				this.showadd = true;

				this.ruleForm.id = e.id;
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.evection_reason = e.evection_reason;
				this.ruleForm.together_evection = e.together_evection;

				var evectionTripList = await this.$globals.AxiosPost("EvectionTrip/SelectDetails", {
					evection_id: e.id
				});
				this.ruleForm.evectionTripList = evectionTripList.data;

				this.$refs["adds"].Initialize();
			},
			//查询
			async Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
				    temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
				    organize_ids += item + ",";
				})
				
				var url = 'StaffEvection/selectAll';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					city_id: this.condition.city_id,
					staff_name: this.condition.staff_name,
					state: this.condition.state,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "StaffEvection/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},

			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.staff_id = '';
				this.ruleForm.evection_reason = '';
				this.ruleForm.together_evection = '';
				this.ruleForm.evectionTripList = [this.ruleForm.evectionTrip];
				this.ruleForm.examineDetailsList = [];
			},
			//初始化组织架构及下面的人
			async organizeFind() {
			    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
			        identification: "1",
			        id: this.condition.project_id
			    });
			    this.organizeList = this.getTreeData(organizeList.data);
			
			},
			getTreeData(data) {
			    // 循环遍历json数据
			    for (var i = 0; i < data.length; i++) {
			
			        if (data[i].organizeList.length < 1) {
			            // children若为空数组，则将children设为undefined
			            data[i].organizeList = undefined;
			        } else {
			            // children若不为空数组，则继续 递归调用 本方法
			            this.getTreeData(data[i].organizeList);
			        }
			    }
			    return data;
			}
		},
		async created() {
			this.Find();
			this.organizeFind();
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}
</style>



// WEBPACK FOOTER //
// Ccsq.vue?48671b47